import {ReactNode, useCallback, useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {useFetchData} from '../common/servercall/useFetchData'
import {TrunkingSite} from '../app/types'
import {useParams} from 'react-router'
import {api} from '../common/api'
import {Page} from '../app/navigation/redux'
import {Grid} from "@mui/material";
import {TitledBody} from "../common/components/TitledBody";
import {WithErrorAndFetching} from "../common/servercall/WithErrorAndFetching";
import {SoiPeeringDetail} from "./soipeering/detail";
import {SoiRegistrationDetail} from "./soiregistration/detail";

export const DetailTrunkingSite = () => {
    const { t } = useTranslation()
    const { id }: { id: string } = useParams()

    const fetchTrunkingSite = useCallback(
        async (productId: string): Promise<TrunkingSite | undefined> => {
            const { data } = await api.get<TrunkingSite>(`/api/trunking/site/${productId}`)
            return data
        },
        [],
    )

    const {
        data,
        isFetching,
        error,
        refetch
    } = useFetchData<TrunkingSite>(useCallback(() => fetchTrunkingSite(id), [fetchTrunkingSite, id]))

    const pageInfo: Page | null = useMemo(
        () =>
            data
                ? {
                    label: `${data.name}`,
                    key: `trunking-sites.trunking-site`,
                }
                : null,
        [data],
    )

    const renderDetails = useCallback((trunkingSite: TrunkingSite): ReactNode => {
        if (trunkingSite.type === 'SIP_OVER_INTERNET_TRUNKING') {
            return SoiPeeringDetail(isFetching, error, refetch, trunkingSite)
        } else if (trunkingSite.type === 'SIP_OVER_INTERNET_REGISTRATION') {
            return SoiRegistrationDetail(isFetching, error, refetch, trunkingSite)
        }
        return <></>
    }, [isFetching, error, refetch])

    return <TitledBody title={t(`trunking-sites.trunking-site`)} page={pageInfo}>
        <Grid container>
            <Grid item xs={12} lg={10}>
                <WithErrorAndFetching<TrunkingSite> isFetching={isFetching} error={error} data={data}
                                                       render={renderDetails}/>
            </Grid>
        </Grid>
    </TitledBody>

}
